
window._ = require('lodash');

global.$ = global.jQuery = require('jquery');

require('bootstrap/dist/js/bootstrap');

window.Vue = require('vue');

window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': window.Laravel.csrfToken,
    'X-Requested-With': 'XMLHttpRequest'
};

const app = new Vue({
    el: '#app'
});